import React from "react";
import ProductContent from "components/common/ProductContent";

interface CourseBodyProps {
  content: string;
  seoCollapsibleContent?: {
    __typename: "Course_Seocollapsiblecontent";
    html: string | null;
  } | null;
}

export default function CourseBody({ content, seoCollapsibleContent }: CourseBodyProps) {
  return <ProductContent content={content} seoCollapsibleContent={seoCollapsibleContent} />;
}
